export const screenNameConstants = {
  LOGIN: "login",
  PROFILE: "myProfile",
  DASHBOARD: "dashboard",
  EVENTS: "events",
  COMPETITIONFEEDBACK: "competition_feedback",
  My_EVENTS: "MY_EVENTS",
  EVENTS_FORM: "eventsForm",
  EVENT: "event",
  VIEW_EVENTS: "view-events",
  VIEW_EVENT_DETAIL: "view-event-details",
  COMPETITIONS: "competitions",
  COMPETITIONS_LEADERBOARD: "competitions leaderboard",
  MY_COMPETITIONS: "MY_COMPETITIONS",
  LEADERBOARD: "leaderboard",
  CALENDAR: "calendar",
  BECOMEVERIFIED: "become_verified",
  USERS: "users",
  INSTRUCTORS: "instructors",
  COURSES: "courses",
  SPOTS: "spots",
  CENTERS: "centers",
  SUBSCRIPTION_SETTINGS: "subscription_settings",
  REGISTRATION: "registration",
  CENTER_REGISTRATION: "center_registration",
  FORGOT_PASSWORD: "forgot_password",
  RESET_PASSWORD: "reset_password",
  BECOME_VERIFIED: "become_verified",
  VERIFY_EMAIL: "verify_email",
  CERTIFIED_PRACTITIONER: "certified_practitioner",
  EMAIL_APPROVAL: "email_approval",
  ADMIN_USERS: "ADMIN_USERS",
  STUDENTS: "MY_STUDENTS",
  CENTERS: "CENTERS",
  CENTER_ACTIVITY: "Activities",
  CENTER_PROFILE: "CENTER_PROFILE",
  CENTER_PENDING_PAYMENT: "CENTER_PENDING_PAYMENT",
  REFUND_POLICY: "REFUND_POLICY",
  SPOT_DETAIL: "SPOT_DETAIL",
  MY_STUDENTS: "MY_STUDENTS",
  MY_COURSES: "MY_COURSES",
  VIEW_COMPETITIONS: "VIEW_COMPETITIONS",
  CALENDAR: "calendar",
  VIEW_UPCOMING_COMPETITIONS: "VIEW_UPCOMING_COMPETITIONS",
  VIEW_PREVIOUS_COMPETITIONS: "VIEW_PREVIOUS_COMPETITIONS",
  ADMIN_PAYMENT_HISTORY: "PAYMENT_HISTORY",
  FREELANCE_PENDING_PAYMENT: "FREELANCE_PENDING_PAYMENT",
  ADMIN_AUDIT_LOGS: "AUDIT_LOGS",
  CENTER_INSTRUCTOR_DETAIL: "CENTER_INSTRUCTOR_DETAIL",
  BOAT_CLASSES: "BOAT_CLASSES",
};

export const viewPathConstants = {
  LOGIN: "/login",
  PROFILE: "/profile",
  DASHBOARD: "/dashboard",
  EVENTS: "/events",
  COMPETITIONFEEDBACK: "/competition-feedback",
  MY_EVENTS: "/my-events",
  EVENTS_FORM: "/event-form",
  EVENT: "/event",
  VIEW_EVENTS: "/view-events",
  VIEW_EVENT_DETAIL: "/view-event-details",
  COMPETITIONS: "/competitions",
  PUBLIC_COMPETITIONS: "/public-competitions",
  COMPETITION_LEADERBOARD: "/competition-leaderboard",
  My_COMPETITIONS: "/my-competitions",
  PUBLIC_COMPETITIONS_DETAIL: "/public-competitions-detail",
  VIEW_COMPETITIONS: "/view-competitions",
  ADD_COMPETITIONS: "/add-competations",
  MY_COMPETITIONS_DETAIL: "/my-competitions-detail",
  LEADERBOARD: "/leaderboard",
  CALENDAR: "/calendar",
  BECOMEVERIFIED: "/become-verified",
  USERS: "/users",
  INSTRUCTORS: "/instructors",
  COURSES: "/admin/courses",
  SPOTS: "/spots",
  SUBSCRIPTION_SETTINGS: "/subscription-settings",
  DEFAULT_PATH: "/",
  REGISTRATION: "/registration",
  CENTER_REGISTRATION: "/center-registration",
  FORGOT_PASSWORD: "/forgotpassword",
  RESET_PASSWORD: "/resetpassword",
  BECOME_VERIFIED: "/becomeverified",
  VERIFY_EMAIL: "/verifyemail",
  CERTIFIED_PRACTITIONER: "/certifiedpractitioner",
  EMAIL_APPROVAL: "/emailapproval",
  UNKNOWN_PATH: "*",
  REGISTRATION_SUCCESS: "/registrationsuccess",
  NOTIFICATION: "/notification",
  ADMIN_USERS: "/admin-users",
  STUDENTS: "/students",
  CENTERS: "/centers",
  CENTER_PROFILE: "/center-profile",
  CENTER_PENDING_PAYMENT: "/center-payment",
  DISABLED_INSTRUCTOR: "/disabled-instructor",
  CENTER_INSTRUCTORS: "/center-instructors",
  CENTER_STUDENTS: "/center-students",
  CENTER_ACTIVITY: "/center-activity",
  VIEW_CENTERS: "/view-centers",
  VIEW_CENTER_PROFILE: "/view-center-profile",
  VIEW_INSTRUCTOR_PROFILE: "/view-instructor-profile",
  REFUND_POLICY: "/refund-policy",
  VIEW_ALL_SPOTS: "/view-all-spots",
  VIEW_SPOT_DETAIL: "/spot-detail",
  CENTER_STUDENTS: "/center/students",
  STUDENT_COURSES: "/courses",
  VIEW_UPCOMING_COMPETITIONS: "/view-upcoming-competitions",
  VIEW_PREVIOUS_COMPETITIONS: "/view-previous-competitions",
  ADMIN_PAYMENT_HISTORY: "/admin-payment-history",
  FREELANCE_PENDING_PAYMENT: "/freelance-payment",
  ADMIN_AUDIT_LOGS: "/admin-audit-logs",
  CENTER_INSTRUCTOR_DETAIL: "/center-instructor-detail",
  BOAT_CLASSES: "/boat-classes",
  MY_EVENTS_DETAIL: "/my-events-detail",
};

export const LanguageToggler = {
  LANGUAGE_CHANGE: "LANGUAGE_CHANGE",
  DIRECTION_CHANGE: "DIRECTION_CHANGE",
};

export const Languages = {
  EN: "en",
  AR: "ar",
};

export const PreferedLanguages = {
  ARABIC: 0,
  ENGLISH: 1,
};

export const Directions = {
  rtl: "rtl",
  ltr: "ltr",
};

export const UserVerificationApprovalStatus = {
  NotRequested: 0,
  Approved: 1,
  Rejected: 2,
  Pending: 3,
  Disabled: 4,
};

export const StorageKeys = {
  Token: "token",
  Role: "role",
  KeepMeSignedIn: "keepMeSignedIn",
  activeRole: "activeRole",
  userVerificationDocumentStatus: "verificationDocumentStatus",
  userSportDocumentStatus: "practionerDocumentStatus",
  instructorStatus: "instructorStatus",
  freelanceStatus: "freelanceStatus",
  instructorInvitedCenterName: "instructorInvitedCenterName",
  userBoatClassForCompetitionRegistration:
    "userBoatClassForCompetitionRegistration",
};

export const globalGridActions = {
  ADD: 1,
  EDIT: 2,
  VIEW: 3,
  DELETE: 4,
};

export const DISALLOWED_KEYS_FOR_NUMBER_FIELD = [
  "-",
  "e",
  "ArrowDown",
  "ArrowUp",
];

export const allowedFileTypes = [".pdf", ".jpeg", ".jpg", ".png", ".jfif"];

export const allowedImageTypes = [".jpeg", ".jpg", ".png", ".jfif"];

export const forceReloadPaths = ["/center-instructors"];

export const Levels = {
  LEVEL_1: 1,
  LEVEL_2: 2,
  LEVEL_3: 3,
};

export const table = {
  COLUMN_WIDTH: "180px",
};

export const TableColumnStyle = {
  COLUMN_WIDTH_200: "200px",
  COLUMN_WIDTH_180: "180px",
  COLUMN_WIDTH_160: "160px",
  COLUMN_WIDTH_140: "140px",
  COLUMN_WIDTH_130: "130px",
  COLUMN_WIDTH_120: "120px",
  COLUMN_WIDTH_100: "100px",
  COLUMN_WIDTH_80: "80px",
  COLUMN_WIDTH_70: "70px",
  COLUMN_WIDTH_60: "60px",
  COLUMN_WIDTH_50: "50px",
  COLUMN_WIDTH_40: "40px",

  COLUMN_HEIGHT_200: "200px",
  COLUMN_HEIGHT_180: "180px",
  COLUMN_HEIGHT_160: "160px",
  COLUMN_HEIGHT_140: "140px",
  COLUMN_HEIGHT_130: "130px",
  COLUMN_HEIGHT_120: "120px",
  COLUMN_HEIGHT_100: "100px",
  COLUMN_HEIGHT_80: "80px",
  COLUMN_HEIGHT_70: "70px",
  COLUMN_HEIGHT_60: "60px",
  COLUMN_HEIGHT_50: "50px",
  COLUMN_HEIGHT_40: "40px",
};

export const DateFormatType = "en-GB";

export const TabsConstants = {
  NUMERIC_UPCOMING: 0,
  NUMERIC_PREVIOUS: 1,
};

export const preferedLanguagesContants = {
  Arabic: "عربي",
  English: "English",
};

export const initialGridStateForParams = {
  length: 7,
  search: null,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: "",
};

export const defaultDropDownValue = -1;
export const defaultCountry = 2;

export const timezoneConstants = {
  timezone: "Asia/Riyadh",
  timezoneName: "KSA",
  yearFormat: "YYYY",
  yearFormatForDateObj: "yyyy",
  hourMinuteFormat: "HH:mm",
  monthYearFormat: "MM/YYYY",
  monthYearWordFormat: "MMM YYYY",
  monthYearFormatForDateObj: "MM/yyyy",
  monthYearFullWordFormat: "MMMM YYYY",
  dayMonthYearFormat: "DD/MM/YYYY",
  dayMonthYearFormatForDateObj: "dd/MM/yyyy",
  dateRangeFormat: "DD/MM/YYYY - DD/MM/YYYY",
  dateTimeFormatForTimeStamp: "DD/MM/YYYY HH:mm:ss",
  dateTimeFormatForServer: "YYYY-MM-DD HH:mm:ss",
  twelveAM: { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 },
  twelvePM: { hours: 23, minutes: 59, seconds: 0, milliseconds: 0 },
};

export const bloodTypes = Object.freeze({
  A_POSITIVE: "A+",
  A_NEGATIVE: "A-",
  B_POSITIVE: "B+",
  B_NEGATIVE: "B-",
  AB_POSITIVE: "AB+",
  AB_NEGATIVE: "AB-",
  O_POSITIVE: "O+",
  O_NEGATIVE: "O-",
});

export const genderEnum = Object.freeze({
  MALE: 0,
  FEMALE: 1,
  MIXED: 2,
});

export const genderEnumReversed = Object.freeze({
  0: "male",
  1: "female",
  2: "MIXED",
});

export const modalConstants = Object.freeze({
  BecomeInstructor: "BecomeInstructor",
  BecomePractitioner: "BecomePractitioner",
  BecomeVerified: "BecomeVerified",
});

export const calculationOperations = Object.freeze({
  addition: "addition",
  subtraction: "subtraction",
  multiplication: "multiplication",
  division: "division",
});
